/** Success-state gate. This module has no network, DOM, email, or Google dependency. */
function createFormLeadGate({ formId = '1178218', storage, publish, permission, now = Date.now, uuid = () => crypto.randomUUID(), diagnostic = true }) {
  const key = `vm_trial_form_${diagnostic ? "diagnostic" : "accepted"}_v1:${formId}`;
  let armedAt = null, busy = false;
  const permitted = () => { const p = permission(); return p?.analytics === true && p?.marketing === true && p?.saleOfData !== false; };
  return {
    arm({ id, trusted, valid }) { if (String(id) === formId && trusted === true && valid === true) armedAt = now(); },
    cancel() { armedAt = null; },
    async success({ id, confirmed }) {
      if (String(id) !== formId || confirmed !== true || armedAt === null || busy) return 'ignored';
      const age = now() - armedAt;
      armedAt = null;
      if (age < 0 || age > 120000) return 'expired';
      // Do not queue a later conversion after the visitor refused measurement.
      if (!permitted()) return 'no_consent';
      busy = true;
      try {
        const previous = await storage.getItem(key);
        if (previous) return 'duplicate';
        const eventId = `vmform-${uuid()}`;
        // Persist before dispatch: avoid reload/tab duplicates. Failed dispatch is not silently retried.
        await storage.setItem(key, eventId);
        if (!permitted()) return 'consent_changed';
        await publish('vitomalia:trial_form_accepted_registration', { schema_version: 1, form_id: formId, event_id: eventId, value: 0, currency: 'EUR', diagnostic: diagnostic === true });
        return diagnostic ? 'diagnostic_published' : 'published';
      } catch { return 'storage_or_publish_failed'; }
      finally { busy = false; }
    }
  };
}

(() => {
  'use strict';
  // Enable only after a verified dedicated Google Ads destination and end-to-end acceptance test.
  const ENABLED = true;
  if (!ENABLED || window.Shopify?.designMode) return;
  const FORM_ID = '1178218';
  const CHECKPOINT_KEY = 'vm_form_consent_checkpoint_v1';
  let consentWasReady = false;
  function updateConsentCheckpoint() {
    try {
      const p = window.Shopify?.customerPrivacy;
      const c = p?.currentVisitorConsent?.();
      const ready = c?.analytics === 'yes' && c?.marketing === 'yes' && c?.sale_of_data !== 'no' && p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true;
      if (ready) {
        window.localStorage.setItem(CHECKPOINT_KEY, JSON.stringify({purpose_version:'vm_form_measurement_v1', observed_at:new Date().toISOString(), analytics:'yes',marketing:'yes'}));
        if (!consentWasReady && typeof window.Shopify?.analytics?.publish === 'function') window.Shopify.analytics.publish('vitomalia:form_consent_ready', {});
      } else window.localStorage.removeItem(CHECKPOINT_KEY);
      consentWasReady = ready;
    } catch { consentWasReady = false; }
  }
  document.addEventListener('visitorConsentCollected', updateConsentCheckpoint);
  updateConsentCheckpoint();
  const consentTimer = setInterval(updateConsentCheckpoint,10000);
  window.addEventListener('pagehide',()=>{clearInterval(consentTimer);document.removeEventListener('visitorConsentCollected',updateConsentCheckpoint);},{once:true});

  const mounted = new WeakSet();
  function permissions() {
    const p = window.Shopify?.customerPrivacy;
    if (!p) return {};
    try {
      const c = p.currentVisitorConsent();
      const checkpoint = JSON.parse(window.localStorage.getItem('vm_form_consent_checkpoint_v1'));
      const age = Date.now() - Date.parse(checkpoint?.observed_at);
      if (checkpoint?.purpose_version !== 'vm_form_measurement_v1' || checkpoint.analytics !== 'yes' || checkpoint.marketing !== 'yes' || !Number.isFinite(age) || age < -300000 || age > 1800000) return {};
      return {analytics: c?.analytics === 'yes' && p.analyticsProcessingAllowed() === true, marketing: c?.marketing === 'yes' && p.marketingAllowed() === true, saleOfData: c?.sale_of_data !== 'no'};
    } catch { return {}; }
  }
  function mount(container) {
    const host = container.querySelector('shopify-forms-embed');
    const root = host?.shadowRoot;
    if (!root || mounted.has(root)) return;
    mounted.add(root);
    const gate = createFormLeadGate({
      formId: FORM_ID, storage: window.localStorage, permission: permissions, diagnostic: false,
      publish: async (name, data) => {
        if (typeof window.Shopify?.analytics?.publish !== 'function') throw new Error('Pixel bus unavailable');
        await window.Shopify.analytics.publish(name, data);
      }
    });
    root.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('data-testid') !== 'form') return;
      gate.arm({id:FORM_ID, trusted:event.isTrusted, valid:!form.querySelector('[aria-invalid="true"]')});
    }, true);
    const inspect = () => {
      const current = root.querySelector('#app-embed');
      if (current?.getAttribute('data-current-step') !== 'success' || !root.querySelector('[data-testid="banner-success"]') || root.querySelector('form[data-testid="form"]')) return;
      gate.success({id:FORM_ID, confirmed:true}).then(result => {
        if (result !== 'ignored') container.setAttribute('data-vm-lead-result',result);
      });
    };
    new MutationObserver(inspect).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['data-current-step']});
    // Deliberately no initial success call: a restored success view is not a new submission.
  }
  const scan = () => document.querySelectorAll('[data-forms-id="forms-root-'+FORM_ID+'"]').forEach(mount);
  scan();
  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement,{subtree:true,childList:true});
  // Shopify attaches its shadow root asynchronously without necessarily changing light DOM.
  let attempts = 0;
  const timer = setInterval(() => {scan(); if (++attempts >= 60) clearInterval(timer);},500);
  window.addEventListener('pagehide',()=>{observer.disconnect();clearInterval(timer);},{once:true});
})();
